export default {
    "reference_profile": "Эталонный профиль",
}